import { useSelector } from 'react-redux';
import { getNasServices } from '../model';
import { useBackToOrder } from './useBackToOrder';
import { getOrder } from '../../../../Checkout/store/order/selectors';

export const useRefundNasServices = ({ onSuccess }: { onSuccess: () => void }) => {
	const order = useSelector(getOrder);
	const { onBackToOrder } = useBackToOrder(true);
	const nasServices = useSelector(getNasServices);

	return {
		services: nasServices?.services || [],
		selectedServices: nasServices?.selectedServices || [],
		onSuccessfullyRefunded: onSuccess,
		onCancel: onBackToOrder,
		order,
		travellersToRefund: order.travellers.map(traveller => traveller.id),
		isRefundOrExchange: true
	};
};
